/**
 * Ets2PlaceOfDeliveryStatus generated based on backend enum.
 */
export type Ets2PlaceOfDeliveryStatus =
  | 'Undefined'
  | 'Approved'
  | 'Rejected'
  | 'Pending';

export const Ets2PlaceOfDeliveryStatus = {
  Undefined: 'Undefined' as Ets2PlaceOfDeliveryStatus,
  Approved: 'Approved' as Ets2PlaceOfDeliveryStatus,
  Rejected: 'Rejected' as Ets2PlaceOfDeliveryStatus,
  Pending: 'Pending' as Ets2PlaceOfDeliveryStatus,
};
